import { useState } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { ICampanha } from "../interfaces/ICampanha";

export const useCampanhas = () => {
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();
    const apiEstabelecimento = ApiFactory.getApi("MS_ESTABELECIMENTOS");

    const executar = async (callback: () => Promise<any>, mensagemErro: string) => {
        setLoading(true);
        try {
            const { data } = await callback();
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || mensagemErro, { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    };

    const criar = (campanha: ICampanha) => executar(
        () => apiEstabelecimento.post("/campanhas", campanha),
        "Ocorreu um erro ao criar a campanha"
    );

    const atualizar = (uuid: string, campanha: ICampanha) => executar(
        () => apiEstabelecimento.put(`/campanhas/${uuid}`, campanha),
        "Ocorreu um erro ao atualizar a campanha"
    );

    const buscar = (uuid: string) => executar(
        () => apiEstabelecimento.get(`/campanhas/${uuid}`),
        "Ocorreu um erro ao buscar a campanha"
    );

    const listarLogs = (uuid: string) => executar(
        () => apiEstabelecimento.get(`/campanhas/${uuid}/logs`),
        "Ocorreu um erro ao buscar os logs da campanha"
    );

    const acao = (uuid: string, nome: "abrir" | "pausar" | "retomar" | "finalizar" | "cancelar") => executar(
        () => apiEstabelecimento.put(`/campanhas/${uuid}/${nome}`),
        `Ocorreu um erro ao ${nome} a campanha`
    );

    return {
        criar,
        atualizar,
        buscar,
        listarLogs,
        abrir: (uuid: string) => acao(uuid, "abrir"),
        pausar: (uuid: string) => acao(uuid, "pausar"),
        retomar: (uuid: string) => acao(uuid, "retomar"),
        finalizar: (uuid: string) => acao(uuid, "finalizar"),
        cancelar: (uuid: string) => acao(uuid, "cancelar"),
        loading
    };
};
